import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px;
  max-width: 1200px;
  // margin: 0 auto;
`;

export const Card = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 24px;
  margin-bottom: 20px;
`;

export const CardHeader = styled.div`
  margin-bottom: 20px;
`;

export const CardContent = styled.div`
  margin-bottom: 20px;
`;

export const ExpansionPanel = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  margin-bottom: 16px;
  overflow: hidden;
`;

export const ExpansionPanelSummary = styled.div`
  background: #f5f5f5;
  padding: 16px 20px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e0e0e0;
  
  &:hover {
    background: #eeeeee;
  }
`;

export const ExpansionPanelDetails = styled.div`
  padding: 20px;
`;

export const HelpText = styled.div`
  background: #f8f9fa;
  padding: 16px;
  border-radius: 4px;
  border-left: 4px solid #007bff;
  
  h3 {
    margin: 0 0 8px 0;
    font-size: 16px;
    font-weight: 600;
    color: #333;
  }
  
  p {
    margin: 0 0 8px 0;
    color: #666;
    line-height: 1.5;
  }
  
  .variables-container {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 12px;
  }
  
  .fl-tag {
    background: #e3f2fd;
    color: #1976d2;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    cursor: pointer;
    
    &:hover {
      background: #bbdefb;
    }
  }
`;

export const TemplateForm = styled.div`
  margin-bottom: 20px;
  padding: 16px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background: #fafafa;
`;

export const TemplateRow = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-start;
  margin-bottom: 16px;
`;

export const RemoveButton = styled.button`
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 12px;
  cursor: pointer;
  font-size: 14px;
  
  &:hover {
    background: #c82333;
  }
`;

export const AddButton = styled.button`
  background: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 10px 16px;
  cursor: pointer;
  font-size: 14px;
  margin-top: 16px;
  
  &:hover {
    background: #0056b3;
  }
`;